/* eslint-disable */
// @ts-nocheck

import { useContext, useState } from 'react'

import { ChevronDoubleRightIcon } from '@heroicons/react/24/solid'

import Modal from '../../../../../components/modals/GenericModal'
import { translateMeasure } from '../../../../../utils/translate'
import {
  DispatchProductContext,
  FieldProductData,
  VisualData,
} from './ProductMovementStep'
import QuantitySelector from './QuantitySelector'
import VariationProductContainer from './VariationProductContainer'

export default function SendList() {
  const { products, fields } = useContext(DispatchProductContext)
  const [modal, setModal] = useState<FieldProductData | null>(null)
  const [variationModal, setVariationModal] = useState<VisualData | null>(null)

  //Get if available product is 0 ---------------------------------------------------------
  const lessEqualZero = (value: number | undefined) => {
    if (value === undefined) return false
    if (value <= 0) {
      return true
    } else {
      return false
    }
  }

  const formatAvailability = (value: unknown): string => {
    const num = Number(value)
    if (isNaN(num) || Math.abs(num) < 0.0001) return '0'
    const rounded = Number(num.toFixed(2))
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2)
  }

  //---------------------------------------------------------------------------------------

  //onClick product event ------------------------------------------------------------------
  const onClickProduct = (item: VisualData) => {
    if (item.variations.length !== 0) {
      setVariationModal(item)
    } else {
      const data: FieldProductData = {
        available: item.available,
        measure: item.measure,
        productName: item.name,
        productId: item.productId,
      }
      setModal(data)
    }
  }
  //--------------------------------------------------------------------------------------
  return (
    <>
      {products!.map((item, idx) => {
        const index = fields!.findIndex(
          (elem) => elem.productId === item.productId
        )

        const variationQuant = (varId: number) => {
          return fields!.find((elem) => elem.variationId === varId)?.quantity
        }

        const quantity = fields!
          .filter((elem) => elem.productId === item.productId)
          .reduce((t, v) => (v.quantity ?? 0) + t, 0)

        return (
          <button
            className={`my-2 inline-flex w-full items-center rounded-md border border-slate-200 p-5 shadow-md ${
              index !== -1 && 'ring-2 ring-slate-500'
            } ${
              lessEqualZero(item.available) ? 'bg-red-50' : 'hover:bg-slate-50'
            }`}
            key={idx}
            onClick={() => index === -1 && onClickProduct(item)}
            type="button"
          >
            <div className="flex flex-grow flex-col">
              <p className="text-md text-start font-semibold">{item.name}</p>
              {item.variations.map((variation, idx) => (
                <div
                  className="inline-flex gap-3 pl-2 text-sm text-gray-400"
                  key={idx}
                >
                  <p>{`${variation.name} `}</p>
                  <p
                    className={
                      variationQuant(variation.id) ? 'line-through' : ''
                    }
                  >{`${formatAvailability(variation.available)} ${translateMeasure(
                    item.measure
                  )}`}</p>
                  {variationQuant(variation.id) && (
                    <p>{`${formatAvailability(variation.available - variationQuant(variation.id))} ${translateMeasure(
                      item.measure
                    )}`}</p>
                  )}
                </div>
              ))}
            </div>
            <div className="flex flex-shrink flex-col gap-y-2">
              <p
                className={`text-sm text-slate-400 ${
                  index !== -1 && 'line-through'
                }`}
              >
                Disponible:{' '}
                {`${formatAvailability(item.available)} ${translateMeasure(item.measure)}`}
              </p>
              {index !== -1 && (
                <>
                  <p className={`text-sm text-slate-400`}>
                    Disponible:{' '}
                    {formatAvailability(item.available - (quantity ?? 0))}
                    {translateMeasure(item.measure)}
                  </p>
                  <span className="flex items-center justify-end">
                    {formatAvailability(quantity)}
                    <ChevronDoubleRightIcon className="h-5 text-slate-500" />
                  </span>
                </>
              )}
            </div>
          </button>
        )
      })}

      {modal && (
        <Modal close={() => setModal(null)} state={!!modal}>
          <QuantitySelector close={() => setModal(null)} productData={modal} />
        </Modal>
      )}
      {variationModal && (
        <Modal close={() => setVariationModal(null)} state={!!variationModal}>
          <VariationProductContainer
            close={() => setVariationModal(null)}
            product={variationModal}
          />
        </Modal>
      )}
    </>
  )
}
